module.exports = __webpack_public_path__ + "img/ewm_wx.66e47370.png";